import { render, staticRenderFns } from "./PreparedMessagesHeader.vue?vue&type=template&id=73ab58da&scoped=true&"
import script from "./PreparedMessagesHeader.vue?vue&type=script&lang=js&"
export * from "./PreparedMessagesHeader.vue?vue&type=script&lang=js&"
import style0 from "./PreparedMessagesHeader.vue?vue&type=style&index=0&id=73ab58da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ab58da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
